module.exports = __webpack_public_path__ + "img/broiler-blue.ac53021f.png";